import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Form, Button } from "reactstrap";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import APICall from "../../services/apiCall";
import { toast } from "react-toastify";

const RequestDeleteApplicationForm = (props) => {
  const {
    setOpenDeleteModal,
    applicationData,
    loginUserDetails,
    applicationList,
    setFetchAfterUpdate,
    setFirstStartupApplicationBoolean,
    setSelectedApiNames,
    setApiLimitNote,
    fetchAfterUpdate,
    setSelectedAppId,
  } = props;

  const { register, handleSubmit, errors } = useForm();
  const [isDeleteButtpnDisable, setIsDeleteButtpnDisable] = useState(false);
  const onSubmit = (values) => {
    setFetchAfterUpdate(false);

    const body = {
      app_id: applicationData.app_id, // Selected Application AppID
      request_by: loginUserDetails.user_name, //[loggedin user username/email],
      comment_from_requester: values.comment || "", //optional if we get comment from user then only pass else blank
      devid:loginUserDetails.dev_id,
    };
    setIsDeleteButtpnDisable(true);

    APICall.servertrip(
      "POST",
      "request_application_delete",
      loginUserDetails,
      undefined,
      body
    )
      .then((res) => {
        setOpenDeleteModal(false);
        setFetchAfterUpdate(true);
        setSelectedAppId({ appid: applicationData.app_id });

        toast.success(res.data?.message);
        if (applicationList.length === 1) {
          setFirstStartupApplicationBoolean(false);
          setSelectedApiNames([]);
          setApiLimitNote("");
          setIsDeleteButtpnDisable(true);
        }
      })
      .catch((error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setOpenDeleteModal(false);
        setFetchAfterUpdate(false);
        setIsDeleteButtpnDisable(true);
      });
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            <SikkaInput
              label="Comment"
              placeholder="write your comment"
              id="comment"
              name="comment"
              innerRef={register({
                required: "Comment is required",
                pattern: {
                  value: /^[^\s]+(\s+[^\s]+)*$/,
                  message: "Invalid comment",
                },
              })}
              errors={errors}
            />
          </Col>
        </Row>

        <Row
          form
          className="modal-footer px-md-3 bg-light"
          style={{
            marginLeft: "-16px",
            marginRight: "-16px",
            marginBottom: "-16px",
          }}
        >
          <Button
            size="sm"
            className="ml-auto"
            color="outline-danger"
            type="submit"
            disabled={isDeleteButtpnDisable}
          >
            Request Delete
          </Button>
          <Button
            color="outline-secondary"
            size="sm"
            onClick={() => {
              setOpenDeleteModal(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </>
  );
};

export default RequestDeleteApplicationForm;
